import { makeAutoObservable } from "mobx";
import { BreadcrumbItem } from "src/appStore";
import {
  loadCatalog,
  loadCatalogSchemes,
} from "src/business/catalog/apiCatalog";
import { CatalogsTreeStore } from "src/business/catalog/CatalogsTree/CatalogsTreeStore";
import { ZCatalog } from "src/business/catalog/ZCatalog";
import { recordsLoader } from "src/business/records/recordsLoader";
import { CatalogRecordFilters } from "src/business/records/ZCatalogRecord";
import { ZCatalogRecordSafe } from "src/business/records/ZCatalogRecordSafe";
import { ZSpecificationTyped } from "src/business/specification";
import { RemoteData } from "src/common/RemoteData";
import { insertColumnAfter } from "src/components/ReactiveTable/insertColumnAfter";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { sysWfStatusColumn } from "src/pages/catalogs/RecordsPage/sysWfStatusColumn";
import { PageUrl } from "src/routes/PageUrl";

import { createRecordColumns } from "../../../business/records/createRecordColumns";

export type RecordsData = {
  catalog: ZCatalog;
  schemes: ZSpecificationTyped[];
  table: RtStore<ZCatalogRecordSafe, CatalogRecordFilters>;
  tree: CatalogsTreeStore;
};

export const recordsPageStore = makeAutoObservable({
  async init(catalogId: string) {
    this.setCatalogId(catalogId);
    try {
      this.setData({ status: "wait" });
      const [catalog, schemes] = await Promise.all([
        loadCatalog(catalogId),
        loadCatalogSchemes(catalogId),
      ]);
      const table = new RtStore({
        rowKey: "id",
        loader: recordsLoader(catalogId, schemes),
        defaultRequest: { pageSize: 20 },
      });
      const tree = new CatalogsTreeStore(catalog);
      this.setData({
        status: "ready",
        result: { catalog, schemes, table, tree },
      });
    } catch (error) {
      this.setData({ status: "error", error });
    }
  },
  dispose() {
    this.setData({ status: "none" });
  },
  get columns(): RtColumn<ZCatalogRecordSafe>[] {
    const { data } = this;
    const columns =
      data.status === "ready"
        ? createRecordColumns(
            data.result.schemes,
            data.result.catalog.displayAttribute,
            data.result.catalog.classifiers,
          )
        : [];
    return insertColumnAfter(columns, "displayId", sysWfStatusColumn);
  },
  catalogId: "",
  setCatalogId(id: string) {
    this.catalogId = id;
  },
  data: { status: "none" } as RemoteData<RecordsData>,
  setData(newData: RemoteData<RecordsData>) {
    this.data = newData;
  },
  get title(): BreadcrumbItem[] {
    const res: BreadcrumbItem[] = [
      { title: "Каталоги", page: PageUrl.catalogs },
    ];
    const { data } = this;
    if (data.status === "ready") {
      res.push({ title: data.result.catalog.name });
    }
    return res;
  },
});
